import { render, staticRenderFns } from "./download-resource-button.vue?vue&type=template&id=e45ac35e&scoped=true"
import script from "./download-resource-button.vue?vue&type=script&lang=js"
export * from "./download-resource-button.vue?vue&type=script&lang=js"
import style0 from "./download-resource-button.vue?vue&type=style&index=0&id=e45ac35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45ac35e",
  null
  
)

export default component.exports